<mat-icon
  class="{{ stateToColor(event) }}"
  [svgIcon]="stateToIcon(event)"
  [matTooltip]="stateToText(event)">
</mat-icon>
